export default __webpack_public_path__ + "img/minipro.ad42612c.png";